import * as PIXI from "pixi.js";
import { Coord } from "../../../types/Interface";
import ColorOptionConRenderer from "./ColorOptionConRenderer";
import SwitcherButton from "../SwitcherButton/SwitcherButton";
import ColorCircle from "./ColorCircle";
import { colorOptEventBus, EnumColorOptEventBus } from "./ColorOptEventBus";


export default class ColorOptionCon {
  private ColorOptionConRenderer: ColorOptionConRenderer;
  private Buttons: SwitcherButton[] = [];

  constructor(centerCoord: Coord, conWidth: number) {
    this.ColorOptionConRenderer = new ColorOptionConRenderer(centerCoord, conWidth, this.onHandleButton, this.onHandleSecButton);
    this.Buttons = this.ColorOptionConRenderer.getButtons();
    setTimeout(() => {
      this.setSelectedButton(0);
    }, 10);
  }
  public setAllDisabled = (v: boolean) => this.Buttons.forEach(b => b.setDisabled(v));
  private onHandleButton = (index: number) => this.setSelectedButton(index);
  private onHandleSecButton = () => { };
  addToCon = (con: PIXI.Container) => con.addChild(this.ColorOptionConRenderer);
  setSelectedButton(index: number) {
    this.Buttons.forEach((b, bI) => {
      const icon = b.icon as ColorCircle;
      icon.draw(bI == index)
      if (bI !== index) {
        return b.closeButton();
      }
      colorOptEventBus.emit(EnumColorOptEventBus.selectedColor, icon.color)
    })
  }
}